module.exports = __webpack_public_path__ + "static/img/qiye 06@2x.be19c7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/entry/qiye 06@2x.png
// module id = e05N
// module chunks = 0